module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/logo/logo_rectangle.svg","name":"SECC Saint-Barthélemy","short_name":"SECC SB","start_url":"/","background_color":"#232536","theme_color":"#232536","display":"minimal-ui","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fdc70358fbc5333ed03d868457465f1d"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"languages":["fr","en"],"defaultLanguage":"fr","siteUrl":"https://seccsb.com","i18nextOptions":{"fallbackLng":"fr","supportedLngs":["fr","en"],"defaultNS":"common","interpolation":{"escapeValue":false}},"pages":[{"matchPath":"/form-submission","excludeLanguages":["en","fr"]}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
